import { atom } from 'infrastructure/state/jotai.wrapper'
import { INode } from 'shared/types/tree'
import { createIdMap, NodeIdMap } from '../../version_mapping/utility'
import { treeSummaryMappings, summaryDataByMasterId } from './utility'
import { SummaryCSVData } from './types'

export const treeAtom = atom<{ tree?: INode; resetTree?: () => void }>({})
export const updatingAtom = atom(false)

export const treeIdMappingAtom = atom<NodeIdMap | undefined>((get) => {
  const { tree } = get(treeAtom)
  if (!tree) return undefined
  return createIdMap(tree)
})

export const currentSheetDataAtom = atom<
  { data: SummaryCSVData[]; headers: string[] } | undefined
>(undefined)

export const curriculaTitlesForSheetAtom = atom((get) => {
  const result = get(currentSheetDataAtom)
  if (!result) return []
  const titleSet = result.data.reduce<Set<string>>(
    (acc, { curriculumTitle }) => {
      acc.add(curriculumTitle)
      return acc
    },
    new Set(),
  )
  return Array.from(titleSet)
})

export const summaryDataByMasterIdAtom = atom((get) => {
  const result = get(currentSheetDataAtom)
  if (!result) return {}
  const { data, headers } = result
  return summaryDataByMasterId(headers, data)
})

export const treeSummariesAtom = atom(async (get) => {
  const { tree } = get(treeAtom)
  if (!tree) return

  const data = await get(summaryDataByMasterIdAtom)

  return Object.values(data).find(
    ({ curriculumTitle }) => curriculumTitle === tree.title,
  )
})

export const summaryMappingAtom = atom(async (get) => {
  const { tree } = get(treeAtom)
  const summaries = await get(treeSummariesAtom)

  if (!tree || !summaries) return

  return treeSummaryMappings(summaries, tree)
})
